/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Uses_External_Case_IdentifierInputs */

const en_clients_field_uses_external_case_identifier = /** @type {(inputs: Clients_Field_Uses_External_Case_IdentifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client has a case identifier code`)
};

const pt_br2_clients_field_uses_external_case_identifier = /** @type {(inputs: Clients_Field_Uses_External_Case_IdentifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente possui código identificador de caso`)
};

/**
* | output |
* | --- |
* | "Client has a case identifier code" |
*
* @param {Clients_Field_Uses_External_Case_IdentifierInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_uses_external_case_identifier = /** @type {((inputs?: Clients_Field_Uses_External_Case_IdentifierInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Uses_External_Case_IdentifierInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_uses_external_case_identifier(inputs)
	return pt_br2_clients_field_uses_external_case_identifier(inputs)
});